//   _____  ____   _____  _____  __ __  _____  _____  ____
//  /   __\/  _/  /   __\/  _  \/  |  \/  _  \/  _  \/    \
// |   __||  |---|   __||   __/|  _  ||  _  ||  |  |\-  -/
// \_____/\_____/\_____/\__/   \__|__/\__|__/\__|__/ |__|
//
export const banner = (): void => {
  console.log(
    atob('IF9fX19fICBfX19fICAgX19fX18gIF9fX19fICBfXyBfXyAgX19fX18gIF9fX19fICBfX19fIA0KLyAgIF9fXC8gIF8vICAvICAgX19cLyAgXyAgXC8gIHwgIFwvICBfICBcLyAgXyAgXC8gICAgXA0KfCAgIF9ffHwgIHwtLS18ICAgX198fCAgIF9fL3wgIF8gIHx8ICBfICB8fCAgfCAgfFwtICAtLw0KXF9fX19fL1xfX19fXy9cX19fX18vXF9fLyAgIFxfX3xfXy9cX198X18vXF9ffF9fLyB8X198DQogICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICA='),
    atob('CiAgICAgICAgICAgICAgICAgICAgICAgIGJ5IFRU')
  )
}
